import { queryOptions } from "@tanstack/react-query";
import type { Server } from "@/app/servers/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { serversKeys } from "./query-keys";

const fetchServer = async (options: {
  client: ApiClient;
  id: string;
}): Promise<Server> => {
  const { client, id } = options;
  const { data } = await client.get<Server>(`/workers/${id}`);
  return data;
};

export const getServerQueryOptions = ({
  id,
  binding = "project",
  scope,
}: {
  id: string;
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<Server>({
    queryKey: serversKeys.detail({ binding, scope, id }),
    queryFn: () => fetchServer({ client, id }),
  });
};
